import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import QRCode from 'qrcode.react';
import Customer from "../customer";
import { format } from "../../utils/timer";
import { Controller, useForm } from "react-hook-form";
import { Hidden } from "react-awesome-styled-grid";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import SmallScreenView from "../smallscreen";
import { COUNTRY_PHONE_CODE, TABLET_SCREEN_WIDTH } from "../../appconstants";
import {
  addUpiPaymentsChargeById,
  payInvoiceById,
  getServerEncription,
  generateClientKeyPair,
  encryptData,
} from "../../api";
import {
  FlexContainer,
  H1Text,
  Hr,
  Input,
  LabelText, SpanText,
  SubmitButton,
  PH3Text,
  UpiPanel,
  UpiPanel2,
  Text,
  Img,
} from "../../design";
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import QRIcon from "../../assets/imgs/qr-img.svg";
import Arrow from "../../assets/imgs/qr-arrow.svg";
import User from "../../assets/imgs/Wallet.svg";
import applePay from '../../assets/imgs/applePay.png';
import googlePay from '../../assets/imgs/googlePay.png';
import swireQrpay from '../../assets/imgs/swireQrpay.png';
import ReCAPTCHA from 'react-google-recaptcha';
import { AmountDivideByHundred } from "../../helper";
import { TabNames } from "../../appconstants";

type Props = {
  errorMsg: string,
  errorHeader: string,
  customerReadOnly: boolean,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  customerFields: {
    name: string,
    contactUsEmail: string,
    contactUsPhone: string,
  },
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  alpha2: string,
  cancel: Function,
  getPaymentById: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  paymentWidget: boolean,
  upiUrl: String,
  count: Number,
  expireyText: string,
  paymentMethodDetails: boolean,
  paymentPageDetails: boolean,
  showMobileViewUpi: boolean,
  paymentPagePay: boolean,
  invoicePay: boolean,
  hideQr: boolean,
  paymentPageMeta: string,
  currentCustomerGid: string,
  supportPhoneNumber: string,
  showCustomer: boolean,
  requiredPhone: boolean,
  showWhatsAppNotify: boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  prefix: String,
  tax: Number,
  discount: Number,
  totalPayable: Number,
  subTotal: Number,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  paymentMethodType: Boolean,
  paymentPageEntries : Object,
  paymentInterval: String,
  seatPagePay : Boolean,
  invoiceLinkGid: String,
  employeeDetails: Object,
  surcharge: Number,
  setRecaptchaModalVisible: Function,
  setSavedPaymentDetails: Function,
  savedPaymentDetails: Object,
  globalRecaptchaToken: String,
  setGlobalRecaptchaToken: Function,
  setRecaptchaPaymentType: Function,
}

const InstantPayment = (props: Props) => {
  const { submit, expireyText, count, preFillCustomer, discount, paymentWidget, showWhatsAppNotify, paymentPagePay, customerFields, showCustomer, surcharge,
    headerText, buttonText, errorHeader, errorMsg, supportPhoneNumber, hideQr, requiredPhone, sitekey, isCaptchaEnabled, serviceFee, serviceFeeRate, tip, serviceFeeRateVal, amount, serviceFeeVal, prefix, tax, totalPayable, subTotal,
    customerReadOnly, customerValidation, alpha2, showCancelBtn, cancel, cancelButtonText, upiUrl, getPaymentById, paymentMethodDetails, paymentPageDetails, paymentPageMeta, showMobileViewUpi, currentCustomerGid, invoicePay,
    netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, swirepayUS, paymentMethodType, metaGid, metaPageEntries, paymentInterval, seatPagePay, invoiceLinkGid, employeeDetails, donationPay, donationPageEntry,
    setRecaptchaModalVisible, setSavedPaymentDetails, savedPaymentDetails, globalRecaptchaToken, setGlobalRecaptchaToken, setRecaptchaPaymentType } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [customerReadOnlyList, setCustomerReadOnlyList] = useState([]);
  const [showQrCode, setShowQrCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hideUpiId, setHideUpiId] = useState(true);
  const [qrCodeText, setQRCodeText] = useState('');
  const [invalidQR, setInvalidQR] = useState(null);
  const [styleClass, setStyleClass] = useState('col-sm-7 pl-0');
  const [paymentSession, setPaymentSession] = useState('');
  const [psClientSecret, setPsClientSecret] = useState('');
  const [redirectionUri, setRedirectionUri] = useState('');
  let apiInterval;
  const [checked, setChecked] = useState(false);
  const [recaptchaToken, setRecaptchToken] = useState(null);
  const [showCaptchError, setShowCaptchError] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
  const countryCallingCode = (phone && `+${phone.countryCallingCode}`) || (alpha2 && `+${getCountryCallingCode(alpha2)}`);

  const defaultCustomerValues = {
    cname: (customerFields && customerFields.name) || "",
    email: (customerFields && customerFields.contactUsEmail) || "",
    phone: (phone && phone.nationalNumber) || "",
    countryCallingCode: (countryCallingCode && findCountryCallingCode(countryCallingCode)) || "",
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  useEffect(() => {
    if (paymentWidget) {
      setStyleClass('col-sm-12 pl-0');
    }
  }, [paymentWidget]);

  useEffect(() => {
    if (globalRecaptchaToken
      && savedPaymentDetails
    ) {
      onClickQrCode(savedPaymentDetails, globalRecaptchaToken);
      setGlobalRecaptchaToken(null);
      setRecaptchaPaymentType(null);
    }
  }, [globalRecaptchaToken]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: defaultCustomerValues // <-- ADD THIS
  });

  useEffect(() => {
    setValue('notify', checked);
  }, [checked]);

  // useEffect(() => {
  //   const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
  //   const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
  //   reset({
  //     cname: customerFields && customerFields.name || "",
  //     email: customerFields && customerFields.contactUsEmail || "",
  //     phone: phone && phone.nationalNumber || "",
  //     countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
  //   })
  // }, [reset, customerFields]);

  useEffect(() => {
    setCustomerReadOnlyList([]);
    if (customerReadOnly) {
      setCustomerReadOnlyList(['name', 'email', 'phone']);
    }
  }, [props.customerReadOnly]);

  // useEffect(() => {
  //   if (errorMsg) {
  //     setShowErrorMessage(true);
  //   } else setShowErrorMessage(false);
  // }, [errorMsg]);

  const onSubmit = data => {
    if (recaptchaToken) {
      setShowCaptchError(null);
    } else {
      setShowCaptchError('Captcha is required');
    }
    const { phone, countryCallingCode, cname, email, notify } = data;
    const phoneNumber = phone ? countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}` : null;
    const customer = { name: cname, email, phoneNumber };
    const finalData = { ...data, customer, notify, recaptchaToken };
    if (submit) { submit(finalData) }
  };

  useEffect(() => {
    if (!hideUpiId) {
      const interval = setInterval(() => {
        getPaymentById(paymentSession, psClientSecret, redirectionUri);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [hideUpiId]);


  const onClickQrCode = async (data, recaptchaToken = null) => {
    const originalData = data;
    if (data === 'prev') {
      clearInterval(apiInterval);
      setHideUpiId(true);
    } else {
      setLoading(true);
      let data;
      if (paymentMethodDetails === true) {
        if(swirepayUS){
          data = {
            "paymentMethodDetails": {
              type: "WALLET",
              subType:"SWIREPAY_US",
              swirepayUS: {
                type: "QR",
              },
            },
          }
        } else {
          data = {
            "paymentMethodDetails": {
              type: "INSTANT_PAYMENT",
              instantPayment: {
                type: "QR",
              },
            },
          }
        }
      } else {
        if(swirepayUS){
          data = {
            "paymentMethod": {
              type: "WALLET",
              subType:"SWIREPAY_US",
              swirepayUS: {
                type: "QR",
              },
            }
          }
        } else {
          data = {
            "paymentMethod": {
              type: "INSTANT_PAYMENT",
              instantPayment: {
                type: "QR",
              },
            },
          }
        }
      }
      if (paymentMethodType === true) {
        data.paymentMethodType = ["WALLET"];
      }
      if(paymentPagePay) {
        data.paymentPageEntries = metaPageEntries;
        data.paymentPageMetaGid = metaGid;
      }
      if(seatPagePay) {
        data.seatPageTicketEntries = metaPageEntries;
        data.seatPageMetaGid = metaGid;
      }
      if (amount) {
        data.amount = amount;
      }
      if (paymentInterval) {
        data.interval = paymentInterval;
      }
      if(invoicePay) {
        data.paymentMethod.customerGid = currentCustomerGid;
      }
      if(donationPay) {
        data.donationPageMetaGid = metaGid;
        data.notes = donationPageEntry?.notes;
        data.shareAddress = donationPageEntry?.shareAddress;
        data.shareName = donationPageEntry?.shareName;
        data.shareEmail = donationPageEntry?.shareEmail;
        data.sharePhoneNumber = donationPageEntry?.sharePhoneNumber;
      }
      if (paymentWidget && employeeDetails) {
        data = { ...data, ...employeeDetails };
      }
    
      try {
        const serverSideEncryptionValue = await getServerEncription(recaptchaToken);
        if (serverSideEncryptionValue?.public_key) {
          const keys = generateClientKeyPair();
          if (keys?.privateKey) {
            const encriptedData = encryptData(
              JSON.stringify(data),
              serverSideEncryptionValue.public_key,
              keys.privateKey,
              serverSideEncryptionValue.key_id
            );
            const payload = {
              publicKey: keys?.publicKey,
              keyId: encriptedData?.keyId,
              iv: encriptedData?.iv,
              data: encriptedData?.encryptedData,
            };
            if (encriptedData?.keyId) {
              let value = null;
              if (invoicePay) {
                value = await payInvoiceById(invoiceLinkGid, payload);
              } else {
                value = await addUpiPaymentsChargeById(upiUrl, payload);
              }
              if (value && value.nextActionUrl) {
                const { nextActionUrl } = value;
                if (nextActionUrl) {
                  window.location = nextActionUrl;
                  return;
                }
              }
              if (value && value.qrUrl) {
                setPaymentSession(value.paymentSessionGid || null);
                setPsClientSecret(value.psClientSecret || null);
                setRedirectionUri(value.redirectUri || null);
                setQRCodeText(value.qrUrl);
                setLoading(false);
                setHideUpiId(false);
              } else if (value && value.paymentSession) {
                setQRCodeText(value.paymentSession.qrUrl);
                setPaymentSession(value.paymentSession.gid || null);
                setPsClientSecret(value.paymentSession.psClientSecret || null);
                setRedirectionUri(value.redirectUri || null);
                setLoading(false);
                setHideUpiId(false);
              }
            }
          }
        }
      } catch (err) {
        console.log(err, 'err');
        setLoading(false);
        setHideUpiId(true);
        if (err?.status === 429){
          setSavedPaymentDetails(originalData);
          setRecaptchaPaymentType(TabNames.INSTANT_PAYMENT);
          setRecaptchaModalVisible(true);
          return;
        }
        setInvalidQR((err && err.data && err.data.message) || 'QR payment was not supported')
        setShowErrorMessage(true);
      }
    }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  const customSubmitButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' :  '100%'),
    backgroundColor: '#0b64bc',
    height: '43px',
    margin: '0px',
  };

    const isFormValid = () => {
    // Get current form values
    const formValues = watch();
    
    const formValid = formValues.walletAlias;

    // Return overall validation
    return formValid;
  };

  return (
    <>
      {
        expireyText && (
          <p className="px-4 px-md-4 mb-4">
            {expireyText} <span style={{ fontWeight: "600" }}>{format(count)}</span>
          </p>
        )
      }
      <H1Text
        className="px-4 px-md-4 mb-0"
      >
        {headerText || "PAY WITH WALLET Alias & QR "}
      </H1Text>
      {
        (
          <>
            <form
              hidden={showQrCode}
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)(e);
              }}
              onChange={() => setShowErrorMessage(false)}
              style={{
                width: '100%',
              }}
              className="px-4 px-md-1"
            >
              {

                loading ? (
                  <>
                    <div style={{ marginLeft: '150px' }} className="spinner-border text-muted mr-4"> </div>
                  </>
                ) : (
                  <FlexContainer
                    flexDirection="column"
                  >
                    {
                      hideUpiId ? (
                        <>
                          <div className="px-1 px-md-4 mt-2 w-100">
                            <FlexContainer
                              xs="100%"
                              md="100%"
                              gap="5%"
                            >
                              {
                                showCustomer ? (
                                  <>
                                    <div>
                                      <Customer 
                                        control={control} 
                                        errors={errors}
                                        watch={watch}
                                        readOnly={customerReadOnlyList} 
                                        requiredPhone={requiredPhone} 
                                        validation={customerValidation} 
                                      />
                                    </div>
                                    <Hr />
                                  </>) : (
                                  <></>
                                )
                              }
                            </FlexContainer>
                            <div className="row m-0">
                              <div className={styleClass}>
                                {/* {
                                  showCustomer ? (
                                    <>
                                      <div>
                                        <Customer 
                                          control={control} 
                                          errors={errors} 
                                          readOnly={customerReadOnlyList} 
                                          requiredPhone={requiredPhone} 
                                          validation={customerValidation} 
                                        />
                                      </div>
                                      <Hr />
                                    </>) : (
                                    <></>
                                  )
                                } */}
                                <LabelText>
                                  Wallet Alias <span style={{ color: 'red' }}>*</span>
                                </LabelText>
                                <Controller
                                  defaultValue={""}
                                  color={errors.walletAlias ? "red" : "inherit"}
                                  marginBottom="0px"
                                  control={control}
                                  name="walletAlias"
                                  placeholder="Enter wallet alias"
                                  rules={{
                                    required: 'This field is required',
                                  }}
                                  as={Input}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="walletAlias"
                                  render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                  )}
                                />
                                {/* {
                                  showWhatsAppNotify && (
                                    <div className="mt-3">
                                      <label>
                                        <Controller
                                          marginBottom="0px" name='notify' control={control} as={<Input type="checkbox"
                                            defaultChecked={checked}
                                            onClick={({ target }) => setChecked(target.checked)} width="auto" />} />
                                        <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
                                    </div>
                                  )
                                } */}
                                {
                                  sitekey && (isCaptchaEnabled === true) && (
                                    <div className="mt-3">
                                      <ReCAPTCHA
                                        sitekey={sitekey}
                                        value={recaptchaToken}
                                        onChange={(value) => {
                                          setRecaptchToken(value);
                                          setShowCaptchError(null);
                                        }}
                                      />
                                      {
                                        (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                                        ) : showCaptchError ? (
                                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                                        ) : ''
                                      }
                                    </div>
                                  )
                                }
                                {
              (serviceFee || serviceFeeRate || discount || subTotal) && (
                <div class="mt-4">
                  <Hr />
                  <table class="table table-bordered mt-4">
                    <tbody>
                      <tr style={{ borderBottom: 'hidden' }}>
                        <th scope="row">Amount:</th>
                        <td>{prefix} {AmountDivideByHundred(amount)}</td>
                      </tr>
                      {
                        discount && discount !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Discount:</th>
                            <td>{prefix} ({AmountDivideByHundred(discount)})</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {
                        subTotal && subTotal !== 0 ? (
                          <tr>
                            <th scope="row">Sub Total:</th>
                            <td>{prefix} {AmountDivideByHundred(subTotal)}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {
                        tax && tax !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Tax:</th>
                            <td>{prefix} {tax ? (AmountDivideByHundred(tax)) : 0.00}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {
                        serviceFeeVal && serviceFeeVal !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Service Fee:</th>
                            <td>{prefix} {AmountDivideByHundred(serviceFeeVal)}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                                            {
                                              surcharge && surcharge !== 0 ? (
                                                <tr style={{ borderBottom: 'hidden' }}>
                                                  <th scope="row">Surcharge:</th>
                                                  <td>{prefix} {AmountDivideByHundred(surcharge)}</td>
                                                </tr>
                                              ) : (
                                                <></>
                                              )
                                            }
                      {
                        tip && tip !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Tip:</th>
                            <td>{prefix} {AmountDivideByHundred(tip)}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      <tr style={{ background: '#F7F7F7' }}>
                        <th scope="row">Total Payable:</th>
                        <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayable)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            }
                              </div>
                            </div>
                          </div>
                          {
                            !hideQr && (
                              <>
                                <Hr />
                                <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                                  <div className="row m-0">
                                    <div
                                      onClick={() => onClickQrCode('next')}
                                      className={styleClass}>
                                      <UpiPanel>
                                        <Img
                                          style={{
                                            marginTop: '19px',
                                            marginLeft: '16px',
                                          }}
                                          src={QRIcon}
                                        />
                                        <PH3Text>Show QR</PH3Text>
                                        <PH3Text
                                          marginTop='5px'
                                          fontSize='11px'
                                          color='#848484'
                                        >
                                          Scan the QR code using your Instant Payment app
                                        </PH3Text>
                                        <p
                                          style={{
                                            marginLeft: '93%',
                                            marginTop: '-19px',
                                          }}
                                        >
                                          <Img
                                            src={Arrow}
                                          />
                                        </p>
                                      </UpiPanel>
                                    </div>
                                  </div>
                                </div>
                                <Hr />
                              </>
                            )
                          }

{
                            (serviceFeeEnabled === true) && (
                              <div className="px-1 px-md-4">
                                <div class="mt-4">
                                  <table class="table table-bordered mt-4">
                                    <tbody>
                                      <tr style={{ borderBottom: 'hidden' }}>
                                        <th scope="row">Amount:</th>
                                        <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                                      </tr>
                                      <tr style={{ borderBottom: 'hidden' }}>
                                        <th scope="row">Service Fee:</th>
                                        <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                                      </tr>
                                      <tr style={{ background: '#F7F7F7' }}>
                                        <th scope="row">Total Payable:</th>
                                        <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )
                          }

                          <div className="px-1 px-md-4">
                            <FlexContainer
                              width="100%"
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              {
                                showCancelButton && cancel &&
                                <SpanText
                                  onClick={onCancel}
                                  cursor="pointer"
                                  color="#40A9FF"
                                  className="cursor-pointer mr-5 pt-3"
                                >{cancelButtonText || "Cancel"}</SpanText>
                              }
                              <SubmitButton
                                style={customSubmitButtonStyle}
                                type="submit"
                                disabled={!isFormValid()}
                              >{buttonText || "PAY"}</SubmitButton>
                            </FlexContainer>
                            {/* {isShowErrorMessage && <PaymentError header={errorHeader} message={invalidQR || errorMsg} />} */}
                            {isShowErrorMessage && <PaymentError header={errorHeader} message={invalidQR} />}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                            <div className="row m-0">
                              <div
                                onClick={() => onClickQrCode('prev')}
                                className={styleClass}>
                                <UpiPanel>
                                  <Img
                                    style={{
                                      marginTop: '19px',
                                      marginLeft: '16px',
                                    }}
                                    src={User}
                                  />
                                  <PH3Text>Wallet Alias</PH3Text>
                                  <PH3Text
                                    marginTop='5px'
                                    fontSize='11px'
                                    color='#848484'
                                  >
                                    Use your Swirepay wallet alias
                                  </PH3Text>
                                  <p
                                    style={{
                                      marginLeft: '90%',
                                      marginTop: '-19px',
                                    }}
                                  >
                                    <Img
                                      src={Arrow}
                                    />
                                  </p>
                                </UpiPanel>
                              </div>
                            </div>
                          </div>
                          <Hr />
                          <div className="px-1 mt-2 mb-4 w-100">
                            <div className="row m-0">
                              <div className={styleClass}>
                                <H1Text className="mt-4">
                                  PAY USING QR CODE
                                </H1Text>
                                <UpiPanel2>
                                  <PH3Text
                                    marginTop='40px'
                                    fontSize='11px'
                                    marginLeft='0px'
                                    color='#848484'
                                  >
                                    Scan QR using  Swirepay Wallet
                                  </PH3Text>
                                  <div
                                    style={{
                                      marginTop: '15px',
                                      display: 'inline-block',
                                    }}
                                  >
                                    <Img
                                      src={swireQrpay}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      marginTop: '20px',
                                    }}
                                  >
                                    <QRCode
                                      id="qrCodeEl"
                                      size={160}
                                      value={qrCodeText}
                                    />
                                  </div>
                                </UpiPanel2>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    }
                  </FlexContainer>
                )
              }
            </form>
          </>
        )
      }
    </>
  )
};

export default InstantPayment;
